<div class="insights">
  <h1 class="insights__title">Insights</h1>

  <div class="more-container">
    <h2 class="insights__header">Other Brain Resources</h2>

    <div class="desktop-items">
      @for (slide of moreSlidesStoreList; track slide) {
        <a
          class="carousel__item carousel__item--desktop"
          [ngClass]="{'carousel__item--disabled': slide.disabled || !slide.url}"
          (click)="navigateToSlideUrl(slide)"
          >
          @if (slide.imageSrc) {
            <div class="carousel__image">
              <img [src]="slide.imageSrc" alt="">
            </div>
          }
          <div class="carousel__label">
            {{slide.title}}
          </div>
          <div class="carousel__lock">
            <img src="/assets/images/dashboard/insights/index/lock-icon--blue.svg" alt="">
          </div>
        </a>
      }
    </div>
  </div>
</div>
